export default {

    messageInfo: function (_this, type, content) {
        if ("success" == type) {
            let secondsToGo = 3;
            const modal = _this.$success({
                title: "提示",
                content: content,
                centered: true,
                width: "300px"
            });
            const interval = setInterval(() => { }, 1000);
            setTimeout(() => {
                clearInterval(interval);
                modal.destroy();
            }, secondsToGo * 1000);
        } else {
            let secondsToGo = 3;
            const modal = _this.$error({
                title: "提示",
                content: content,
                centered: true,
                width: "300px"
            });
            const interval = setInterval(() => { }, 1000);
            setTimeout(() => {
                clearInterval(interval);
                modal.destroy();
            }, secondsToGo * 1000);
        }
    },
    isEmail: function (email) {
        var regEmail = /^([a-zA-Z]|[0-9])(\w)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        return regEmail.test(email);
    },
    isPhone: function (phone) {
        var reg =
            /^(13[0-9]|14[5-9]|15[012356789]|16[5-7]|17[0-8]|18[0-9]|19[135689])[0-9]{8}$/;
        return reg.test(phone);
    },
    checkPwd: function (password) {
        return /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~/\\-]).{8,}$/.test(password);
    },
}